import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Marquee from "../components/ClientsMarquee";
import Services from "../components/Services";
import ServicesDetail from "../components/ServicesDetail";
import GetQuote from "../components/GetQuote";
import Stats from "../components/Stats";
import Process from "../components/Process";
import About from "../components/About";
import Testimonials from "../components/Testimonials";
import Careers from "../components/Careers";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <main data-testid="home-page" className="bg-white text-[color:var(--fis-ink)]">
      <Navbar />
      <Hero />
      <Marquee />
      <Services />
      <ServicesDetail />
      <GetQuote />
      <Stats />
      <Process />
      <About />
      <Testimonials />
      <Careers />
      <Contact />
      <Footer />
    </main>
  );
}
